import React, { useState } from 'react';

import SearchOverlayControls from './search-overlay-controls';

import { CloseSvg } from '../common/svg';

import '../../styles/common/search-overlay.scss';

const SearchOverlay = (props) => {
  const [query, setQuery] = useState('');
  
  return (
    <div className={`search-overlay ${(props.expanded) ? 'expanded' : ''}`}>
      <button 
        className="search-close-button"
        onClick={() => {
          setQuery('');
          props.closeOverlayClick();
        }}
      >
        { CloseSvg }
      </button>
      <div className="search-panel">
        <div className="search-bar">
          <p className="label">
            Search The Public Domain Review
          </p>
          <SearchOverlayControls
            searchOverlayFieldRef={props.searchOverlayFieldRef}
            expanded={props.expanded}
            query={query}
            setQuery={setQuery}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchOverlay;